<template>
  <div
    v-if="displayProps && displayProps.length"
    class="c-review-selections-item-props"
  >
    <h3
      v-for="{ key, label, value } in displayProps"
      :key="key"
      class="c-review-selections-item-props__prop"
      :class="[
        't-paragraph-small',
        'u-margin-bottom-none'
      ]"
    >
      <span
        class="c-review-selections-item-props__prop-key"
      >
        {{ label }}:
      </span>
      <span
        class="c-review-selections-item-props__prop-value"
        :style="propValueStyle({ key, value })"
      >
        {{ value }}
      </span>
    </h3>
  </div>
</template>

<script>
const engravingKeys = [
  'font',
  'text',
  'location'
]
export default {
  props: {
    item: {
      type: Object,
      default: () => ({})
    },
    lineItemProps: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    engravingLocation() {
      const item = this.item
      const items = this.lineItemProps
      let result = false
      for (let { key, value } of (items || [])) {
        if (key === 'location') {
          result = (value === item.name)
          break
        }
      }
      return result
    },
    engravingFont() {
      const items = this.lineItemProps
      let result
      for (let { key, value } of (items || [])) {
        if (key === 'font') {
          result = value
          break
        }
      }
      return result
    },
    displayProps() {
      const engravingLocation = this.engravingLocation
      const items = this.lineItemProps
      let result = []
      for (let { key, value } of (items || [])) {
        if (
          engravingKeys.includes(key) &&
          engravingLocation
        ) {
          result.push({
            key,
            value,
            label: `Engraving ${key}`
          })
        }
      }
      return result
    }
  },
  methods: {
    propValueStyle({ key }) {
      let result
      switch (key) {
      case 'font':
      case 'text':
        result = {
          'font-family': this.engravingFont
        }
      }
      return result
    }
  }
}
</script>

<style lang="scss" scoped>
.c-review-selections-item-props {
  &__prop-key {
    text-transform: uppercase;
  }
}
</style>
